// ----------------------------------------------------------------------------
// Template: Password
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/page-header/page-header';

// Styles
import './_password.scss';
